module.exports = __webpack_public_path__ + "fonts/Sarabun-SemiBold.b8efe5f4.ttf";